module.exports = __webpack_public_path__ + "img/exit_4.da325ad5.svg";